import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppSupport from './WhatsappSupport';
import ScrollToTop from './ScrollToTop';
import { MegaMenu } from './MegaMenu';

const AboutPage = () => {
  return (
    <div className='overflow-x-hidden'>
      {/* <Navbar /> */}
      <MegaMenu/>
      <div className=" text-gray-800 ">

        {/* Hero Section */}
        <div className="relative h-[100vh]">
          {/* Background Image */}
          <div className="absolute inset-0 h-full">
            <img
              src="/images/aboutbg.jpg"
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Overlay Content */}
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6 md:px-8 lg:px-16 bg-black bg-opacity-60 space-y-3">
            <h1 className="text-white text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight lg:leading-snug noto">
            Unveiling Our Story and Purpose
            </h1>
            <p className=' text-white hidden sm:block'>Open doors to global opportunities with our overseas education programs and educational tours. Immerse <br /> in new cultures, broaden your knowledge, and elevate your academic and personal development through impactful international experiences.</p>
            <h5 className=' text-white text-xs lg:hidden'>Explore international education opportunities and immersive tours designed to enrich your academic journey and cultural understanding.
            </h5>


          </div>
        </div>

        <section className="container mx-auto px-4 py-8 w-full">
  <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold text-center pb-6 pt-6 text-gray-800 font-noto">
    A Journey Of Us
  </h1>
  <p className="text-gray-600 leading-relaxed text-sm sm:text-base lg:text-lg text-center px-4 sm:px-8 lg:px-16 xl:px-24 2xl:px-32">
    Founded in 2021, Application UNI has grown into a leading educational platform dedicated to providing transformative learning experiences and shaping global citizens. Over the past decade, we have successfully enriched the lives of more than 3,800 students through meticulously planned educational tours, collaborating with 180+ Indian schools to deliver immersive and inspiring journeys that combine education with exploration.
    <br />
    <br />
    Our commitment extends beyond tours—we have proudly supported over 1,000 Indian students in realizing their academic dreams by securing admissions to some of the world’s most prestigious universities. Leveraging strategic partnerships with over 450 international schools and universities, we provide tailored solutions for both educational tours and overseas education, ensuring every student’s unique aspirations are met.
    <br />
    <br />
    Recognizing the growing demand for quality educational services, we recently expanded our footprint to Dubai, securing approval from KHDA to serve students and schools in the UAE and MENA regions. This milestone underscores our dedication to broadening access to world-class educational opportunities, fostering global exposure, and nurturing the leaders of tomorrow.
    <br />
    <br />
    At Application UNI, our mission is to bridge the gap between potential and achievement, offering a seamless blend of academic guidance, experiential learning, and strategic partnerships that inspire students to reach new heights in their educational journeys.
  </p>
</section>




        {/* Organization Story */}
        {/* Mission and Vision */}
        <section className="flex flex-col lg:flex-row items-center py-10 w-[100%] bg-white ">
          {/* Left Image Section */}
          <div className="flex-shrink-0 w-full sm:w-[80%] lg:w-[30%] lg:ml-44 mb-8 lg:mb-0">
            <img
              src="https://www.vidyard.com/wp-content/themes/vidyard-website/img/pages/company/about-us/main-image.png.webp"
              alt="Our Mission"
              className="rounded-lg w-[90%] lg:w-full mx-4 lg:mx-0"
            />
          </div>


          {/* Right Text Section */}
          <div className="w-full lg:w-[30%] text-center lg:text-left lg:ml-40 mx-4">
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-800 mx-2 lg:mx-0">
              Our Mission: Simplifying University Applications
            </h2>
            <p className="mt-6 text-gray-600 text-sm lg:text-lg leading-relaxed roboto ">
              To empower students by bridging the gap between true potential and realistic achievement through innovative educational tours, personalized academic guidance for overseas education, and enlarging strategic partnerships base with global colleges and universities, inspiring students to become lifelong learners and future leaders.
            </p>
          </div>
        </section>

        <section className="flex flex-col lg:flex-row items-center py-10 mt bg-white">
          {/* Left Image Section */}


          {/* Right Text Section */}
          <div className="w-full lg:w-[30%] text-center lg:text-left lg:ml-40 mx-4">
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-800 mx-2 lg:mx-0">
              Our Vision: Digital solutions <br /> for education
            </h2>
            <p className="mt-6 text-gray-600 text-sm lg:text-lg leading-relaxed roboto mb-5">
              To be a global leader in educational services, fostering transformative learning experiences and shaping a generation of socially responsible, globally aware citizens equipped to excel in an ever-evolving world.
            </p>
          </div>
          <div className="flex-shrink-0 w-full lg:w-[35%] lg:ml-44  lg:mb-0">
            <img
              src="https://www.dishaeducationconsultancy.com/wp-content/uploads/2022/10/Vision.png" // Replace with the actual image URL
              alt="Our Vision"
              className="rounded-lg  w-[90%] lg:w-full mx-4 lg:mx-0"
            />
          </div>
        </section>



        <section className="py-10  bg-white w-[80%] mx-auto">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-800 text-center mb-2 lg:mb-12  noto">Our Story</h2>
          <div className="max-w-full mx-auto grid md:grid-cols-2 gap-10 items-center ">
            <div className="text-sm lg:text-lg leading-relaxed text-center lg:text-left ">
              <p className="mb-6">ApplicationUni was founded with a vision to make the dream of studying abroad a reality for students around the world. Our journey began with the belief that every student deserves access to world-class educational opportunities. Over the years, we have built a network of experienced mentors, educational institutions, and support staff dedicated to guiding students on their educational journeys.</p>
              <p>From our humble beginnings, we have grown into a global organization that facilitates educational tours, application guidance, and one-on-one mentorship for students aspiring to study in top universities across the world.</p>
            </div>
            <div>
              <img src="https://www.hubspot.com/hs-fs/hubfs/Rangan-Halligan.jpg?width=851&height=567&name=Rangan-Halligan.jpg  " />
            </div>
          </div>
        </section>




        {/* Team Introductions */}
        {/* <section className="py-20 px-6 md:px-16 bg-white">
          <h2 className="text-3xl lg:text-5xl font-bold text-center mb-12 noto">Meet Our Team</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
            {[1, 2, 3].map((_, idx) => (
              <div key={idx} className="bg-gradient-to-b from-white to-blue-50 p-10 rounded-lg shadow-xl transition-transform transform hover:scale-105 text-center">
                <img src={`/images/team${idx + 1}.jpg`} alt={`Team Member ${idx + 1}`} className="w-32 h-32 rounded-full mx-auto mb-6 border-4 border-blue-500" />
                <h3 className="text-xl font-bold">Sarah Johnson</h3>
                <p className="text-blue-700 font-medium">Co-Founder & CEO</p>
                <p className="mt-4 text-sm">With over 10 years of experience in international education, Sarah leads ApplicationUni with a passion for student success and global learning opportunities.</p>
              </div>
            ))}
          </div>
        </section> */}


      </div>
      <Footer />
      {/* <WhatsAppSupport /> */}
      <ScrollToTop />
    </div>
  );
};

export default AboutPage;
